import { useBusiness } from "@/context/BusinessContext";
import { SiteHeader } from "@/components/landing/SiteHeader";
import { Hero } from "@/components/landing/Hero";
import { Coverage, PricingStrip, Services } from "@/components/landing/Sections";
import { Leadership, SiteFooter } from "@/components/landing/Leadership";

export default function LandingPage() {
  const { profile } = useBusiness();
  if (!profile) {
    return <div className="min-h-screen bg-[#030712] grid place-items-center font-mono text-cyan-400 text-sm blink-caret">BOOTING</div>;
  }
  return (
    <div className="min-h-screen bg-[#030712] text-slate-100" data-testid="landing-page">
      <SiteHeader profile={profile} />
      <Hero profile={profile} />
      <Services profile={profile} />
      <Coverage profile={profile} />
      <PricingStrip profile={profile} />
      <Leadership profile={profile} />
      <SiteFooter profile={profile} />
    </div>
  );
}
